import { splitAt, path } from 'ramda'
import React from 'react'

import { useFormReducer } from './_reducer'

const Context = React.createContext({ form: {} })
const { Provider } = Context
export const useFormState = () => React.useContext(Context)
export const useForm = () => useFormState()?.form || {}

export const useFieldValue = ({ field, path: pathArray }) => {
  const form = useForm()
  const [finalPath, [finalField]] = splitAt(-1, pathArray || [field])
  const value = path([...finalPath, finalField], form)
  const error = path([...finalPath, finalField + '__error'], form)

  return [value, error]
}

const FormHandler = ({ onSubmit, initialState, children }) => {
  const [form, actions] = useFormReducer(initialState)
  const [disabled, setDisabled] = React.useState(false)

  const handleSubmit = e => {
    if (!!e?.preventDefault) e.preventDefault()
    if (onSubmit) onSubmit(form, actions, e)
  }

  const state = { form, ...actions, disabled, setDisabled, handleSubmit }

  return <Provider value={state}>{children}</Provider>
}

export default FormHandler
